import React from 'react';
import { StyleProp, StyleSheet, TextStyle, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import Button from 'shared/components/vxl/Button/Button';
import Illustration, {
  IllustrationKeyType,
} from 'shared/components/vxl/Illustration/Illustration';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleMdText from 'shared/components/vxl/typography/primary/title/TitleMdText';
import { isIOS } from 'shared/constants/platform';
import { PressableAnalyticsProps } from 'shared/hooks/analytics/usePressableAnalytics';
import theme from 'shared/styles/theme';

export interface EmptyStateScreenProps extends PressableAnalyticsProps {
  headlineText: string;
  bodyText?: string;
  illustrationKey: IllustrationKeyType;
  actionButtonText?: string;
  actionOnPress?: () => void;
  content?: React.ReactNode;
  bodyTextStyle?: StyleProp<TextStyle>;
}

export const EmptyStateScreen = ({
  headlineText,
  bodyText,
  illustrationKey,
  actionButtonText,
  actionOnPress,
  content,
  analyticsId,
  customAttributes,
  bodyTextStyle,
}: EmptyStateScreenProps) => {
  const insets = useSafeAreaInsets();

  return (
    <View style={styles.container}>
      <View style={styles.image}>
        <Illustration illustration={illustrationKey} />
      </View>
      {headlineText ? (
        <TitleMdText style={styles.text}>{headlineText}</TitleMdText>
      ) : null}
      {bodyText ? (
        <BodyBaseText style={[styles.text, bodyTextStyle]}>
          {bodyText}
        </BodyBaseText>
      ) : null}
      {content ? content : null}
      {actionButtonText ? (
        <View
          style={[styles.buttonContainer, { paddingBottom: insets.bottom }]}
        >
          <Button
            label={actionButtonText}
            onPress={actionOnPress}
            size="LARGE"
            type="PRIMARY"
            width="FULL"
            analyticsId={analyticsId}
            customAttributes={customAttributes}
          />
        </View>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  buttonContainer: {
    bottom: 0,
    flex: 1,
    justifyContent: 'flex-end',
    paddingVertical: isIOS ? theme.spacing.m : theme.spacing.s,
    width: '100%',
  },
  container: {
    alignItems: 'center',
    flex: 1,
    padding: theme.spacing.m,
  },
  image: {
    height: 126,
    paddingVertical: theme.spacing.m,
    width: 126,
  },
  text: {
    paddingBottom: theme.spacing.s,
    textAlign: 'center',
  },
});

export default EmptyStateScreen;
